var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoAb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.995,
    height: 14.282,
    viewBox: "0 0 19.995 14.282",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_608",
    "data-name": "Grupo 608",
    transform: "translate(-1323 -104)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_432",
    "data-name": "Rect\\xE1ngulo 432",
    transform: "translate(1323 104)",
    fill: "#fff",
    stroke: "#e33aa9",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.426,
    height: 11.426,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 10.426,
    height: 10.426,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8",
    "data-name": "Trazado 8",
    d: "M4.44-8.819H2.007l-.463,1.4H.068l2.508-6.8H3.862l2.521,6.8H4.908ZM2.382-9.954H4.066L3.219-12.5Z",
    transform: "translate(1325.487 120.531)",
    fill: "#e33aa9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_431",
    "data-name": "Rect\\xE1ngulo 431",
    transform: "translate(1331.569 106.856)",
    fill: "#e33aa9",
    stroke: "#e33aa9",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.426,
    height: 11.426,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 10.426,
    height: 10.426,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7",
    "data-name": "Trazado 7",
    d: "M1.27-7.418v-6.8h2.29a2.918,2.918,0,0,1,1.8.474,1.647,1.647,0,0,1,.615,1.39,1.582,1.582,0,0,1-.247.88,1.437,1.437,0,0,1-.687.558,1.376,1.376,0,0,1,.792.528,1.6,1.6,0,0,1,.29.972,1.829,1.829,0,0,1-.6,1.485,2.635,2.635,0,0,1-1.715.514Zm1.347-2.961v1.836H3.77a1.085,1.085,0,0,0,.743-.236.824.824,0,0,0,.267-.652.837.837,0,0,0-.929-.948Zm0-.99h1q1.019-.019,1.019-.845a.8.8,0,0,0-.258-.666,1.317,1.317,0,0,0-.815-.2H2.616Z",
    transform: "translate(1333.823 123.387)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoAb);
export default __webpack_public_path__ + "static/media/Icono AB.9e27fb4d331b520707bca8457f00f432.svg";
export { ForwardRef as ReactComponent };